import 'amfe-flexible';
import Vue from 'vue';
import App from './App';
import { router } from './router';
import axios from 'axios';
import store from './store/store';

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
    fullscreenEl: false
};
Vue.use(preview, options)
Vue.use(preview)
Vue.config.ignoredElements = [
    'wx-open-launch-app',
    'wx-open-launch-weapp'
]

Vue.prototype.axios=axios;  //调用ajax
Vue.prototype.axiosUrl="http://api.daihing.yn-ce.com/v2/dhb";  //调用请求头
Vue.prototype.memberToken="15b05103-9319-479e-918a-74611f61c9dd";  //调用member token
new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
});
